import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { media } from '@carvana/stc-styles';
import { hasMobileUserAgent } from '@carvana/stc-utilities';

import ErrorBoundary from './ErrorBoundary';
import QualiSurvey from './QualiSurvey';

const DisplayController = styled.div`
  &.transposeContent {
    display: none;
  }

  @media print {
    display: none;
  }
`;

const WizardContainer = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  margin: 0 auto;
  &.nativeMobile {
    height: max-content;
  }
`;

const Robe = styled.main`
  background: ${({ theme }) => theme.carvana.white.primary};
  justify-self: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;
  width: 100%;

  ${media.sm`
    background: ${({ theme }) => theme.carvana.gray.background};
  `}

  @media print {
    background-color: white;
  }
`;

const chatContext = {
  contextType: 'carvana_trade'
};

const Header = memo(() => (
  <MfeReactComponent component="default" module="HeaderModule">
    {({ Component: HeaderComponent }) => (
      <HeaderComponent
        environment={process.env.CARVANA_APP_ENVIRONMENT}
        chatContext={chatContext}
        useProvider
      />
    )}
  </MfeReactComponent>
));

const Footer = memo(() => (
  <MfeReactComponent component="default" module="FooterModule">
    {({ Component: FooterComponent }) => (
      <FooterComponent environment={process.env.CVNA_APP_ENVIRONMENT} withoutProvider />
    )}
  </MfeReactComponent>
));

const BasePage = ({ children, transpose }) => {
  const [transposeContent, setTranspose] = useState(transpose);

  useEffect(() => {
    if (transpose !== transposeContent) {
      setTranspose(hasMobileUserAgent() || transpose);
    }
  }, [setTranspose, transpose, transposeContent]);

  return (
    <WizardContainer
      id="wizard-container"
      className={classNames({ nativeMobile: hasMobileUserAgent(window.navigator) })}
    >
      <QualiSurvey />
      <DisplayController className={classNames({ transposeContent })}>
        <Header />
      </DisplayController>
      <ErrorBoundary>
        <Robe id="sell-to-carvana">{children}</Robe>
      </ErrorBoundary>
      <DisplayController className={classNames({ transposeContent })}>
        <Footer />
      </DisplayController>
    </WizardContainer>
  );
};

BasePage.propTypes = {
  children: PropTypes.node.isRequired,
  transpose: PropTypes.bool
};

BasePage.defaultProps = {
  transpose: false
};

export default BasePage;
